import FullscreenDialog from './FullscreenDialog';

export default FullscreenDialog;
